import type { ApiError } from "./types";

const GENERIC_MESSAGE = "Something went wrong. Please try again.";

/** Django's `get_object_or_404` default message shape — always an internal leak. */
const DJANGO_NOT_FOUND_PATTERN = /^No .+ matches the given query\.$/;

const GENERIC_CODES = new Set<ApiError["code"]>([
  "not_found",
  "server_error",
  "network",
  "unknown",
]);

export function toUserMessage(error: ApiError, fallback: string = GENERIC_MESSAGE): string {
  if (GENERIC_CODES.has(error.code)) return fallback;
  if (DJANGO_NOT_FOUND_PATTERN.test(error.message)) return fallback;
  return error.message;
}
